var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeliveryAddress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons-24-/-Outline-/-Places-/-business_main_",
    transform: "translate(-2.000000, -2.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: -5.00000006e-8,
    y: -5.00000006e-8,
    width: 24.0000001,
    height: 24.0000001
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20,3.99999997 L20,20 L18,20 L18,16 L12,16 L12,20 L9.99999999,20 L9.99999999,3.99999997 L20,3.99999997 M22,1.99999996 L7.99999996,1.99999996 L7.99999996,20 L3.99999996,20 L3.99999996,18 L5.99999996,18 L5.99999996,16 L3.99999996,16 L3.99999996,14 L5.99999996,14 L5.99999996,12 L3.99999996,12 L3.99999996,9.99999996 L5.99999996,9.99999996 L5.99999996,7.99999996 L3.99999996,7.99999996 C2.89543046,7.99999996 1.99999996,8.89543049 1.99999996,9.99999996 L1.99999996,22 L14,22 L14,18 L16,18 L16,22 L22,22 L22,1.99999996 Z M14,5.99999998 L12,5.99999998 L12,8.99999998 L14,8.99999998 L14,5.99999998 Z M18,5.99999998 L16,5.99999998 L16,8.99999998 L18,8.99999998 L18,5.99999998 Z M14,11 L12,11 L12,14 L14,14 L14,11 Z M18,11 L16,11 L16,14 L18,14 L18,11 Z",
    id: "---\\u21B3-\\uD83C\\uDF08-Color",
    fillOpacity: 0.8,
    fill: "#000A19",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeliveryAddress);
export default __webpack_public_path__ + "static/media/delivery-address.79b5357b546cd4bdda1d6499f984b603.svg";
export { ForwardRef as ReactComponent };